const setWorksAnimations = (
  mobileImage,
  cardSpecial,
  mobileSpecialContainer,
  cardsWorks,
) => {
  const tl = gsap.timeline({
    scrollTrigger: {
      trigger: mobileSpecialContainer,
      start: "top 70%",
      end: "75% 70%",
      scrub: 1,
      toggleActions: "play none none reverse",
    },
    defaults: {
      duration: 1,
    },
  });

  tl.to(
    mobileImage,
    {
      x: 0,
      y: 0,
    },
    "a",
  );

  tl.to(
    cardSpecial,
    {
      opacity: 1,
      x: 0,
    },
    "a",
  );

  tl.to(
    mobileImage,
    {
      y: -100,
    },
    "b",
  );

  tl.to(
    mobileSpecialContainer,
    {
      x: -mobileImage.offsetWidth + 66,
    },
    "b",
  );

  Array.from(cardsWorks).forEach((card) => {
    const fadeLeftTl = gsap.timeline({
      scrollTrigger: {
        trigger: card,
        start: "10% 75%",
        end: "25% 75%",
        toggleActions: "play none none reverse",
        defaults: {
          duration: 0.3,
        },
      },
    });

    const PADDING = 16;

    gsap.set(card, {
      x: () => card.offsetWidth + PADDING,
    });

    fadeLeftTl.to(card, {
      x: 0,
    });
  });
};

const setNewsAnimations = (
  mobileNewsImage,
  cardNewsEspecial,
  mobileSpecialNewsContainer,
  cardNews,
) => {
  gsap.set(mobileNewsImage, {
    y: 40,
  });

  gsap.set(cardNewsEspecial, {
    x: -100,
    opacity: 0,
  });

  const tl3 = gsap.timeline({
    scrollTrigger: {
      trigger: mobileSpecialNewsContainer,
      start: "-5% 70%",
      end: "105% 70%",
      scrub: 0.3,
      toggleActions: "play none none reverse",
    },
  });

  tl3.to(
    mobileNewsImage,
    {
      y: 0,
    },
    "n",
  );

  tl3.to(
    cardNewsEspecial,
    {
      opacity: 1,
      x: 0,
    },
    "n",
  );

  tl3.to(
    mobileNewsImage,
    {
      y: -300,
    },
    "n2",
  );

  tl3.to(
    mobileSpecialNewsContainer,
    {
      x: mobileNewsImage.offsetWidth - 166,
    },
    "n2",
  );

  cardNews.forEach((cardNews) => {
    gsap.set(cardNews, {
      x: -cardNews.offsetWidth - 16,
    });

    const tl4 = gsap.timeline({
      scrollTrigger: {
        trigger: cardNews,
        start: "top 78%",
        end: "25% 78%",
        toggleActions: "play none none reverse",
      },
      defaults: {
        duration: 0.3,
      },
    });

    tl4.to(cardNews, {
      x: 0,
    });
  });
};

const mobileHomeAnimations = () => {
  const mobileSpecialContainer = document.querySelector(
    ".mobile-special-container",
  );
  const mobileImage = document.querySelector(".mobile-image");
  const cardSpecial = document.querySelector(
    ".mobile-special-container .card-work.main-card",
  );
  const cardsWorks = document.querySelectorAll(
    ".work-section .card-work:not(.card-work.main-card)",
  );
  const mobileSpecialNewsContainer = document.querySelector(
    ".mobile-news-special-container",
  );
  const mobileNewsImage = document.querySelector(".mobile-news-image");
  const cardNewsEspecial = document.querySelector(
    ".mobile-news-special-container .card-news.horizontal",
  );
  const cardNews = document.querySelectorAll(
    ".news-grid-container .card-news:not(.card-news.horizontal)",
  );
  const mm = window.matchMedia("(max-width: 768px)");

  if (
    cardSpecial &&
    mobileImage &&
    mobileSpecialContainer &&
    mm.matches &&
    mobileSpecialNewsContainer &&
    mobileNewsImage &&
    cardNewsEspecial &&
    cardNews
  ) {
    // Works Mobile Animations
    setWorksAnimations(
      mobileImage,
      cardSpecial,
      mobileSpecialContainer,
      cardsWorks,
    );

    // News Mobile Animations
    setNewsAnimations(
      mobileNewsImage,
      cardNewsEspecial,
      mobileSpecialNewsContainer,
      cardNews,
    );
  }
};

export default mobileHomeAnimations;
